import _ from 'lodash';
import TimeZoneService from '../tz.service';

export default class UserInfo {
    constructor(data) {
        this.featureFlags = this.featureFlags || {};
        this.modulesDictionary = this.modulesDictionary || {};
        this.orgId = 0;
        this.userId = 0;
        this.roles = [];
        if (data) {
            // from auth call
            this.setApiToken(data.apiToken);
            // from userInfo call
            // this.setUserInfoCallData(data);
        }
    }

    isInModules(appId) {
        return this.modulesDictionary[appId]; // double negation to force to boolean
    }

    isUserAdmin() {
      return this.rolesDictionary.admin || this.rolesDictionary.Administrator;
    }
    isUserPro() {
      return this.rolesDictionary.pro;
    }
    isUserReadOnly() {
        return !this.isUserAdmin() && !this.rolesDictionary.vanRptVwr && this.rolesDictionary.vanRptRdr;
    }
    isSu() {
        return this.rolesDictionary.su;
    }
    isSuPro() {
        return this.rolesDictionary.suPro;
    }

    setApiToken(token) {
        this.apiToken = token;
        this.ensureTokensParsed();
        this.orgId = this.apiToken.access_token_parsed.orgId;
        this.userId = this.apiToken.access_token_parsed.userId;
        this.roles = this.apiToken.access_token_parsed.roles;
        // computed properties
        // TODO: remove rolesDictionary and just rely on roles
        this.rolesDictionary = buildMembershipDictionary(this.apiToken.access_token_parsed.roles);
    }

    setUserInfoCallData(data) {
        this.userId = data.userId;
        this.orgId = data.orgId;
        this.roles = data.roles;
        this.authType = data.authType;
        this.email = data.email;
        this.name = data.name;
        this.username = data.username;
        this.phone = data.phone;
        this.timezoneDisplay = data.farmG2 ? TimeZoneService.getTimeZoneDisplay(data.timeZoneId) : data.timezoneDisplay;
        this.timezoneId = data.timeZoneId;
        this.orgName = data.orgName;
        this.consentJson = data.consentJson ? JSON.parse(data.consentJson) : undefined;
        this.orgDomain = data.orgDomain;
        this.enablePdf = !!data.enablePdf;
        this.cpmmDialBackHours = data.cpmmDialBackHours || 720;
        this.idleTimeoutMinutes = data.idleTimeoutMinutes;
        this.legacyAlertsHide = data.legacyAlertsHide;
        this.features = data.features;
        this.farmG2 = data.farmG2;
        this.smartDiagnostics = data.smartDiagnostics;
        // todo: update to nome sent  by back end
        this.termsOfService = data.termsOfService;

        let featureFlagMap = {};
        if (data.featureFlags) {
            Object.entries(data.featureFlags).forEach((entry) => {
                featureFlagMap[entry[0]] = (entry[1].toLowerCase() === 'true');
            });
        }
        this.featureFlags = featureFlagMap;

        this.loginTime = new Date(data.lastlogin);
        this.logo = data.logo;
        this.logoIcon = data.logoIcon;
        this.landingUri = data.landingUri;
        this.logoutUrl = data.logoutUrl;

        // computed properties
        // TODO: remove rolesDictionary and just rely on roles
        this.rolesDictionary = buildMembershipDictionary(data.roles);
        this.modulesDictionary = buildMembershipDictionary(this.features);
    }

    //internal helper methods
    ensureTokensParsed() {
        if(this.apiToken) {
            if (!this.apiToken.access_token_parsed) {
                this.apiToken.access_token_parsed = decodeToken(this.apiToken.access_token);
            }
            // if (!this.apiToken.refresh_token_parsed) {
            //     this.apiToken.refresh_token_parsed = decodeToken(this.apiToken.refresh_token);
            // }
        }
    }
}
function buildMembershipDictionary(membershipArray) {
    // parse membership string, remove empty values and duplicates
    var membershipList = _.chain(membershipArray).without('').uniq().value();
    var dictionary = {};

    _.forEach(membershipList, function (item) {
        dictionary[item] = true; // mark each item on the list as available on the dictionary
    });
    return dictionary;
}

// from keycloak.js
function decodeToken(str) {
    if (str) {
        str = str.split('.')[1];

        str = str.replace('/-/g', '+');
        str = str.replace('/_/g', '/');
        switch (str.length % 4) {
            case 0:
                break;
            case 2:
                str += '==';
                break;
            case 3:
                str += '=';
                break;
            default:
                throw 'Invalid token';
        }

        str = (str + '===').slice(0, str.length + (str.length % 4));
        str = str.replace(/-/g, '+').replace(/_/g, '/');

        str = decodeURIComponent(escape(atob(str)));

        str = JSON.parse(str);
    }
    return str;
}
